import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/fiar/FiAR_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/fiar/FiAR_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/fiar/FiAR_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/fiar/FiAR_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/fiar/FiAR_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/fiar/FiAR_Slider_6.jpg';

import Data_FiAR from './Data_FiAR';

function Work_FiAR() {
    const canonical = 'https://studio.norcat.org/OurWork/fiar';
    const title = 'FiAR | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, FiAR is an augmented reality fire extinguisher training product that gives learners realistic, repeatable practice with extinguisher use, emergency response, and hands-on safety training.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the FiAR fire extinguisher training project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the FiAR fire extinguisher training project"
            />
            <DetailedHeader
                heading="A New Standard for Fire Extinguisher Training"
                client="NORCAT"
                service="Augmented Reality"
                date="2020-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrls={[
                    'https://www.youtube.com/watch?v=aHqvqrLB4tY',
                    'https://www.youtube.com/watch?v=mmz5ZOw39MQ',
                ]}
                images={[
                    {
                        image: projectImage1,
                        alt: 'FiAR project screenshot 1',
                    },
                    {
                        image: projectImage4,
                        alt: 'FiAR project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'FiAR project screenshot 3',
                    },
                    {
                        image: projectImage2,
                        alt: 'FiAR project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'FiAR project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'FiAR project screenshot 6',
                    },
                  
                ]}
            />

            {Data_FiAR.content}
        </>
    );
}

export default Work_FiAR;
